import {

  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import React, { Fragment, useContext, useEffect, useState } from "react";

import { Credential, api, IListCredentials } from "../../logic/api";
import SearchIcon from "@mui/icons-material/Search";
import flex from "../../styles/flex";
import { PagedDataView } from "../../components/lists/PagedDataView/PagedDataView";
import SwitchField from "../../components/editable/EditableField/fields/SwitchField";
import CredentialListItem from "./components/CredentialListItem";
import CredentialEditorDialog from "./components/CredentialEditorDialog";
import { SessionContext } from "../../utility/useSession";
import ErrorDialog from "../../components/notifications/errorDialog/ErrorDialog";
import propTypes from "prop-types";
import { useTranslation } from "react-i18next";

const CredentialManager: React.FunctionComponent<{
  customerId?: number;
}> = (props) => {
  const [selectedCredential, setSelectedCredential] = useState<Credential | null>(null);
  const [showEditCred, setShowEditCred] = useState<boolean>(false);
  const [credentialListFetchParams, setCredentialListFetchParams] = useState<IListCredentials>({
    customerId: props.customerId
  });

  const [filter, setFilter] = useState("");

  const deleteCredential = api.hooks.admin.deleteCredential();

  const session = useContext(SessionContext);
  const { t } = useTranslation();


  useEffect(() => {
    setCredentialListFetchParams({ ...credentialListFetchParams, customerId: props.customerId });
  }, [props.customerId]);

  const CredentialDialog = () => {
    if (selectedCredential == null) {
      return <Fragment></Fragment>
    }
    return (
      <CredentialEditorDialog
        credential={selectedCredential}
        show={showEditCred}
        onClose={(didSave) => {
          setSelectedCredential(null);
          setShowEditCred(false);
          if (didSave == true) {
            setCredentialListFetchParams({ ...credentialListFetchParams });
          }
        }}
      ></CredentialEditorDialog>
    );
  };

  return (
    <div>
      <CredentialDialog />
      <ErrorDialog err={deleteCredential.err} />
      <div style={{ padding: 10, textAlign: "right" }}>
        <div style={flex.flexRows}>
          <div style={flex.flexAuto}>
            <TextField
              autoFocus={false}
              label={t("admin.searchCredentials")}
              variant="outlined"
              size="small"
              type="search"
              value={filter}
              onChange={(e) => {
                setFilter(e.currentTarget.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  e.stopPropagation();
                  if (e.currentTarget) {
                    e.currentTarget.blur();
                    setCredentialListFetchParams({
                      ...credentialListFetchParams,
                      filter: filter,
                    });
                  }
                  return false;
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position={"end"}>
                    <IconButton
                      style={{ padding: 0 }}
                      onClick={() => {
                        setCredentialListFetchParams({
                          ...credentialListFetchParams,
                          filter: filter,
                        });
                      }}
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>

          <Fragment>
            <div style={flex.flexAuto}>
              <SwitchField
                onChange={(includeInactive) => {
                  setCredentialListFetchParams({
                    ...credentialListFetchParams,
                    includeInactive: includeInactive,
                  });
                }}
                value={credentialListFetchParams.includeInactive}
              ></SwitchField>
            </div>
            <div style={flex.flexAuto}>
              <div
                style={{ textAlign: "right", paddingTop: 10, color: "grey" }}
              >
                {t("mobile.includeDisabled")}
              </div>
            </div>
          </Fragment>

          <div style={flex.flexFill}></div>


        </div>
      </div>
      <PagedDataView<IListCredentials, Credential>
        apiHook={api.hooks.admin.listCredentials}
        parameters={credentialListFetchParams}
        renderItem={(item) => {

          return (
            <CredentialListItem
              credential={item}
              onEditCredential={(cred) => {
                setSelectedCredential(cred);
                setShowEditCred(true);
              }}
              onDelete={async () => {
                deleteCredential.send(session.current.context, {
                  id: item.id
                }, (result) => {
                  if (result == true) {
                    setCredentialListFetchParams({
                      ...credentialListFetchParams,
                    });
                  }
                });
              }}
            ></CredentialListItem>
          );
        }}
      >
        {t("users.noUsers")}
      </PagedDataView>
    </div>
  );
};

CredentialManager.propTypes = {
  customerId: propTypes.number,
};

export default CredentialManager;

